import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { Modal } from 'antd';
import css from './detailsmodal.module.scss';
export const defaultDetailData = {
    img: '/img/search/error.png',
    title: 'Power Hub',
    desc: `The North Face's first Aconcagua already impressed us with lofty warmth worthy of yurt trips and winter walks through ski towns at night. Now back with even greater protection, the Men's Aconcagua 2 Hooded Jacket brings windproofing into the equation so you can stay our when the winds pick up. It still has the lofty down insulation mixed with synthetic insulation in key areas that would usually get damp in a snowstorm, as well as a DWR treatment to help shed moisture. The only difference is The North Face's WindWall shell for added windproofing.`,
    specParams: [
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
        { key: 'Dimension (folded) (inch)', value: '21*16.5*1.0' },
    ],
};
export default function DetailModal({ isShow = false, data, callBack }: any) {
    const { useLang, useState, useEffect } = useGlobal();
    const [visible, setVisible] = useState(isShow);
    const { t } = useLang('shared');

    useEffect(() => {
        setVisible(isShow);
    }, [isShow]);

    const handleClose = () => {
        callBack(false);
    };

    return (
        <Modal
            width={644}
            centered
            closable={false}
            wrapClassName={css.calculatorsmm100step4detailsModal}
            visible={visible}
            zIndex={1000001}
            maskStyle={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1000000,
                height: '100%',
                background: 'rgba(0,0,0,.45)',
            }}
        >
            <span className="detailModal-closeBtn" onClick={handleClose}>
                ×
            </span>
            <h2 className="detailModal-title">{t('calculators.mm100.step4.detail')}</h2>
            <div className="detailModal-img">
                <Image src={data?.img} layout="fill" className="fullImgs" alt={data?.title} aria-label={data.title} />
            </div>
            <div className="detailModal-detailInfo">
                <h3 className="info-tittle">{data?.title}</h3>
                <p className="info-desc">{data?.desc}</p>
                {data?.specParams?.length > 0 && (
                    <div className="infoSpec">
                        <h3 className="spec-title">{t('calculators.mm100.step4.spec')}</h3>
                        <ul className="specs">
                            {data?.specParams?.map((spec: any, k: number) => (
                                <li className="spec-item" key={k}>
                                    <p className="spec-item-name">{spec?.key}</p>
                                    <p className="spec-item-content">{spec?.value}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </Modal>
    );
}
